import {themeColors} from '../../theme/Theme';
import {BusinessUnitEnum} from '../../schema-types/globalTypes';

export const contactTypeColors = {
  Contact: themeColors.lightBlue,
  Lead: themeColors.lightPink,
  Client: themeColors.lightGreen,
  Departed: themeColors.greyLight,
  Prospect: themeColors.lightWarning,
};

export const clientTypeColors = {
  'FP + DFM': themeColors.lightBlue,
  'FP Only': themeColors.lightPink,
  'DFM only (no IFA)': themeColors.lightYellow,
  'New private client': themeColors.lightPurple,
};

export const propositionTypeLabels: Record<string, string> = {
  institutional: 'Institutional',
  'premier sam only': 'Premier SAM Only',
  'premier with fp': 'Premier with FP',
  'private office sam only': 'Private Office SAM Only',
  'private office with fp': 'Private Office with FP',
  'protection commission': 'Protection Commission',
  'select conversions': 'Select Conversions',
  'select on demand': 'Select On Demand',
  'select sam only': 'Select SAM Only',
  'select with fp': 'Select with FP',
  'select transit': 'Select Transit',
  spp: 'SPP',
  'standalone sp': 'Standalone SP',
  basic: 'Basic',
};

export const propositionTypeColors: Record<string, string> = {
  institutional: themeColors.lightPurple,
  'premier sam only': themeColors.lightBlue,
  'premier with fp': themeColors.lightBlue,
  'private office sam only': themeColors.lightPurple,
  'private office with fp': themeColors.lightPurple,
  'protection commission': themeColors.lightPink,
  'select conversions': themeColors.lightYellow,
  'select on demand': themeColors.lightYellow,
  'select sam only': themeColors.lightYellow,
  'select with fp': themeColors.lightYellow,
  'select transit': themeColors.lightYellow,
  spp: themeColors.lightGreen,
  'standalone sp': themeColors.lightGreen,
  basic: themeColors.lightGreen,
  default: themeColors.greyLight,
};

export const divisionColors: Record<BusinessUnitEnum, string> = {
  AR: themeColors.lightBlue,
  DA: themeColors.lightPink,
  SFP: themeColors.lightYellow,
};
